<template>
  <div class="myOrderListBox">
    <div class="toLogin" v-if="!isLOgin">
      <img src="../../../assets/mescroll/mescroll-empty.png" alt="">
      <p>您还没有登入，去<span @click="toLoginCOntent" style="color:red"> 登入</span></p>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" @scroll.native="pullUpLoading" v-if="isLOgin" class="gundongLIst" :id="'shangScrollBox'+contentId">
      <!-- <div class="myOrderList"> -->
        <div class="toLogin" v-if="!orderList.length">
          <img src="../../../assets/mescroll/mescroll-empty.png" alt="">
          <p>暂无数据</p>
        </div>
        <div class="allOrder" v-for="(itemAll,index) in orderList" :key="index">
            <div class="orderNumber">订单号：{{itemAll.orderNo}}</div>
            <van-card
              v-for="(item,indexItem) in itemAll.orderItemEntityList" :key="indexItem"
              :num="item.quantity"
              :desc="item.productBlandName?'品牌：'+item.productBlandName:''"
              :title="item.productName"
              :thumb="item.productImage"
            >
              <template #price>
                <span>{{shopOrintegral=="shop"?'￥'+item.totalPrice:item.totalIntegral+' 积分'}}</span>
              </template>
            </van-card>
            <div class="oprationOrder">
              <span>{{itemAll.status|changeBlock}}</span>
              <van-button v-if="itemAll.status==10" type="warning" size="small" @click="moneyCon(itemAll.orderNo)">{{shopOrintegral=="shop"?"立即购买":"立即兑换"}}</van-button>
              <van-button type="warning" size="small" v-else @click="orderXiangQing(itemAll)">订单详情</van-button>
            </div>
        </div>
        <div v-if="!noData&&orderList.length>0" class="contentNeirong">加载中…</div>
        <div v-if="noData&&orderList.length>3" class="contentNeirong">-- 没有啦！ --</div>
      <!-- </div> -->
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
	export default {
    props: {
      status: {  //状态
        type: String,
        default:()=>"", //必须是一个函数
        required: false,
      },
      contentId: {  //标识必须传 唯一标识不能传一样的
        type: String,
        default:()=>"", //必须是一个函数
        required: true,
      },
    },
		data(){
			return{
        isLOgin:"", //是否登入
        orderList:[],

        isLoading:false, //下拉刷新
        // 上拉加载
        noData:false, //没有数据了 
        linkDataIng:false, //正在加载中
        page:1, //页码
			}
    },
    filters:{
      changeBlock(str){
				if(str=="0"){
					return "交易已取消"
				}else if(str=="10"){
					return "交易未付款"
				}else if(str=="20"){
					return "交易已付款"
				}else if(str=="40"){
					return "交易已发货"
				}else if(str=="50"){
					return "交易成功"
				}else if(str=="60"){
					return "交易关闭"
				}
			}
    },
		created(){
      this.isLOgin=window.localStorage.civilizationId; //判断用户有没有登入
      this.orederData();
    },
		methods:{
      toLoginCOntent(){
        this.login()
      },
			onRefresh(){
        this.page=1;
        this.orederData();
      },
      moneyCon(orderumber){
            var data={
              typeId: this.wenOrRong,
              orderNo: orderumber,
            }
            this.$http.post(this.javalinkTwo +"mmall/order/orderIsPay",data,{headers:{'Content-Type': 'application/json'}})
            .then(res => {
                if(res.data.success){
                  this.page=1;
                  this.orederData();
                  Toast("操作成功！");
                }else{
                  Toast(res.data.message);
                }
            })
            .catch(err => {
                console.log(err);
            });
      },
      // 订单接口
      orederData(){
        var data={
          typeId:this.wenOrRong,
          userId:window.localStorage.civilizationId,
          orderStatus:this.status
        }
        this.$http.post(this.javalinkTwo +"mmall/order/selectUserOrder",data,{
          params:{
            rows:10,
            sortBy:'create_time',
            desc:true,
            page:this.page
          }
        })
        .then(res => {
            this.isLoading=false;
            this.linkDataIng=false;
            if (res.data.success){
              if(this.page==1){ //第一页
                this.orderList = res.data.data.items; //订单数据
              }else{
                this.orderList = this.orderList.concat(res.data.data.items); //订单数据
              }
              // 判断还有没有数据
              if(res.data.data.items.length<10){
                this.noData=true;
              }else{
                this.page++; //页码加一
                this.noData=false;
              }
            }else{
              this.noData=true;
              this.noData=true;
            }
        })
        .catch(err => {
          this.isLoading=false;
          this.linkDataIng=false;
            console.log(err);
        });
      },
      // 跳转到订单详情
      orderXiangQing(item){
        this.$router.push({path:'/orderDetails',query:{ //订单详情
          orderId:item.orderNo
        }});
      },
      // 上拉加载
      pullUpLoading(){
          var node=document.getElementById('shangScrollBox'+this.contentId);
          // 滚动条底端
          if(node.scrollTop+node.offsetHeight>=node.scrollHeight){ 
            if(!this.noData&&!this.linkDataIng){
                this.linkDataIng=true; //加载中
                this.orederData(); //接口
            }
          }
      }
		}
	}
</script>

<style>
  .myOrderListBox .van-pull-refresh__track {
    width: 100%;
    background: #eee;
    /* height: 100%; */
  }
  .myOrderListBox .van-pull-refresh{
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #fff;
  }
  .myOrderListBox .van-card{
    margin-top: 0px;
  }
  .myOrderListBox .van-card{
    background: #fff;
  }
</style>
<style lang="less" scoped>
  .orderNumber {
      padding: 8px 16px;
      background: #fff;
      box-sizing: border-box;
  }
  .oprationOrder {
      width: 100%;
      background: #fff;
      padding: 8px 16px;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      border-top: 1px solid #eee;
      align-items: center;
  }
  .myOrderListBox{
    width: 100%;
    height: 100%;
    .toLogin{
      width: 100%;
      height: 100%;
      text-align: center;
      background: #fff;
      img{
        width:60%;
        height:auto;
        object-fit:contain;
        margin-top: 80px;
      }
      p{
        width: 100%;
        text-align: center;
      }
    }
    .myOrderList{
      width: 100%;
      height: 100%;
      overflow: auto;
    }
    .allOrder{
      width: 100%;
      margin-bottom: 15px;
    }
  }
  .contentNeirong{
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    padding-bottom: 15px;
  }
</style>
